import React from 'react';
export function SolutionSection() {
  return <section className="bg-white py-16 md:py-24 px-4" data-id="element-194">
      <div className="max-w-4xl mx-auto text-center" data-id="element-195">
        <div className="inline-block bg-green-100 text-green-800 font-sans font-bold px-4 py-1 rounded-full mb-6" data-id="element-196">
          ✅ THE SOLUTION
        </div>

        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-black mb-8" data-id="element-197">
          The Pawfect Shot MegaPack
        </h2>

        <p className="font-sans text-xl md:text-2xl text-gray-700 mb-16 max-w-3xl mx-auto" data-id="element-198">
          A complete dog photography system designed for everyday dog owners who
          want better photos using only their phone.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-199">
          <div className="bg-cream p-8 rounded-2xl flex flex-col items-center justify-center border border-soft-gold/30 shadow-sm" data-id="element-200">
            <span className="text-5xl mb-4" data-id="element-201">📂</span>
            <h3 className="font-sans font-bold text-xl text-black" data-id="element-202">
              Open the guides
            </h3>
          </div>

          <div className="bg-cream p-8 rounded-2xl flex flex-col items-center justify-center border border-soft-gold/30 shadow-sm" data-id="element-203">
            <span className="text-5xl mb-4" data-id="element-204">👀</span>
            <h3 className="font-sans font-bold text-xl text-black" data-id="element-205">
              Choose the style of photo you want
            </h3>
          </div>

          <div className="bg-cream p-8 rounded-2xl flex flex-col items-center justify-center border border-soft-gold/30 shadow-sm" data-id="element-206">
            <span className="text-5xl mb-4" data-id="element-207">📸</span>
            <h3 className="font-sans font-bold text-xl text-black" data-id="element-208">
              Apply it with your dog
            </h3>
          </div>
        </div>

        <div className="font-sans text-xl md:text-2xl text-gray-800 space-y-4 font-medium" data-id="element-209">
          <p data-id="element-210">No overthinking.</p>
          <p data-id="element-211">No technical overwhelm.</p>
          <p data-id="element-212">No more guessing every time you open your camera.</p>
          <p className="text-orange font-bold mt-6 text-2xl md:text-3xl" data-id="element-213">
            Just simple guidance that helps you create photos you'll actually
            love.
          </p>
        </div>
      </div>
    </section>;
}